/**
 * Avalara © 2017
 * file: engines/opus_ui/src/search/ResultsArea.js
 */

import React, { Component } from 'react';
import './ResultsArea.css';
import { connect } from 'react-redux';
import DeliverySystemCard from './DeliverySystemCard';
import CustomerCard from './CustomerCard';
import CustomerLink from './CustomerLink';
import BusinessActivity from './BusinessActivity';
import AvataxAccountCard from './deliveryObjects/AvataxAccountCard';
import AvataxSandboxAccountCard from './deliveryObjects/AvataxSandboxAccountCard';
import AvataxTrustfileAccountCard from './deliveryObjects/AvataxTrustfileAccountCard';
import DeliverySystemLink from './DeliverySystemLink';
import AvataxSummary from './deliveryObjects/AvataxSummary';
import AvataxSandboxSummary from './deliveryObjects/AvataxSandboxSummary';
import AvataxTrustfileSummary from './deliveryObjects/AvataxTrustfileSummary';
import InvoiceLink from './InvoiceLink';
import TransactionLink from './TransactionLink';
import ContactLink from './ContactLink';
import ObligationLink from './ObligationLink';
import UserLink from './UserLink';
import CaseLink from './CaseLink';
import ProductLink from './ProductLink';
import ProductCard from './ProductCard';
import BusinessLicensesCard from './deliveryObjects/BusinessLicensesCard.jsx';
import LoadingCard from './LoadingCard.jsx';

export const resultToRendererMap = {
  deliverySystemCard: DeliverySystemCard,
  customerCard: CustomerCard,
  customerLink: CustomerLink,
  businessActivity: BusinessActivity,
  avataxCard: AvataxAccountCard,
  avataxSandboxCard: AvataxSandboxAccountCard,
  avataxTrustfileCard: AvataxTrustfileAccountCard,
  deliverySystemLink: DeliverySystemLink,
  avataxSummary: AvataxSummary,
  avataxSandboxSummary: AvataxSandboxSummary,
  avataxTrustfileSummary: AvataxTrustfileSummary,
  invoiceLink: InvoiceLink,
  transactionLink: TransactionLink,
  contactLink: ContactLink,
  obligationLink: ObligationLink,
  userLink: UserLink,
  caseLink: CaseLink,
  productLink: ProductLink,
  productCard: ProductCard,
  businessLicensesCard: BusinessLicensesCard,
  loadingCard: LoadingCard,
};

class ResultsArea extends Component {
  render() {
    const searchResults =
      this.props.searchResults && Array.isArray(this.props.searchResults)
        ? this.props.searchResults
        : [];

    const {
      queryParams,
      isFetching,
      auth,
      requestTotalTime,
      dispatch,
      isCaseUpdating,
      caseRequestStatus,
      isCancellationPending,
    } = this.props;
    const { query, caseId } = queryParams;

    const pleaseEnterAQueryResult = (
      <div className="search-status">Please enter a query</div>
    );

    const pleaseWaitResult = <div className="search-status" />;

    const NoResultsResult = (
      <div className="search-status">No Results for {query}</div>
    );

    const searchedResultLength = (
      <div className="results-length">
        About {searchResults.length} results{' '}
        {isFetching ? '' : `(${requestTotalTime} seconds)`}
      </div>
    );

    const searchedResult = searchResults.map((result, index) => {
      const component = resultToRendererMap[result.type];

      const card = component
        ? React.createElement(
            component,
            {
              data: result.data,
              type: result.type,
              auth,
              caseId: caseId || null,
              dispatch,
              isCaseUpdating,
              caseRequestStatus,
              isCancellationPending,
            },
            null
          )
        : null;
      return (
        <div key={index} className="Section">
          {card}
        </div>
      );
    });

    const resultsResult = (
      <div>
        {searchedResultLength}
        {searchedResult}
      </div>
    );

    return (
      <div className="ResultsArea">
        {isFetching
          ? pleaseWaitResult
          : query
          ? searchResults && searchResults.length
            ? resultsResult
            : NoResultsResult
          : pleaseEnterAQueryResult}
      </div>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(ResultsArea);
